import { Component, OnInit, inject } from '@angular/core';
import { CanteenService, ICanteen } from '../canteen.service';
import { ModalController, IonicModule } from '@ionic/angular';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import { TranslatePipe } from '@ngx-translate/core';
import { AppState } from 'src/app/app.module';
import { settingsFeature } from 'src/app/ngrx/settings/settings.feature';
import { SettingsActions } from 'src/app/ngrx/settings/settings.actions';

@Component({
    selector: 'app-canteens',
    templateUrl: './canteens.page.html',
    styleUrls: ['./canteens.page.scss'],
    imports: [IonicModule, TranslatePipe]
})
export class CanteensPage implements OnInit {
  canteenService = inject(CanteenService);
  private modalController = inject(ModalController);
  private store = inject<Store<AppState>>(Store);

  public canteens: ICanteen[] = [];
  private canteen: Observable<{ remember: boolean; rememberedId: string | null }>;
  private rememberCanteen: boolean = true;

  constructor() {
    this.canteen = this.store.pipe(select(settingsFeature.selectCanteen));
  }

  ngOnInit() {
    this.canteenService.canteens().subscribe((canteens: ICanteen[]) => {
      this.canteens = canteens;
    });
    this.canteen.subscribe((storeCanteen: { remember: boolean; rememberedId: string | null }) => {
      this.rememberCanteen = storeCanteen.remember;
    });
  }

  public dismiss(canteen?: ICanteen) {
    if (canteen && this.rememberCanteen) {
      this.store.dispatch(SettingsActions.changeRememberedCanteen({ canteenId: canteen.id }));
    }
    this.modalController.dismiss(canteen);
  }
}
